"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadHistoryRequest = void 0;
var DownloadHistoryRequest_1 = require("./DownloadHistoryRequest");
Object.defineProperty(exports, "DownloadHistoryRequest", { enumerable: true, get: function () { return DownloadHistoryRequest_1.DownloadHistoryRequest; } });
